<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{ 'admin-dashboard.create_new_account' | translate }}</h1>
<div mat-dialog-content class="mat-typography">
  <div [formGroup]="accountForm">
    <mat-form-field appearance="outline" class="input-form">
      <mat-label>{{ 'admin-dashboard.email' | translate }}</mat-label>
      <input
        [attr.id]="'email'"
        autocomplete="off"
        formControlName="email"
        matInput
        required
        type="text"
        [errorStateMatcher]="matcher"
        (input)="resetEmailError()"
      />
      <mat-error>
        <span *ngIf="f.get('email').invalid || (invalidEmailSubject | async)">
          {{ 'admin-dashboard.valid_email_required' | translate }}
        </span>
        <span *ngIf="isEmailAlreadyInUseSubject | async">
          {{ 'admin-dashboard.email_already_exists' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-form">
      <mat-label>{{ 'admin-dashboard.name' | translate }}</mat-label>
      <input
        [attr.id]="'name'"
        autocomplete="off"
        formControlName="name"
        matInput
        [errorStateMatcher]="matcher"
        (input)="resetNameError()"
      />
      <mat-error>
        <span *ngIf="f.errors?.requiredName">
          {{ 'admin-dashboard.name_required' | translate }}
        </span>
        <span *ngIf="isNameAlreadyInUseSubject | async">
          {{ 'admin-dashboard.name_already_used' | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-form">
      <mat-label>{{ 'admin-dashboard.firstname' | translate }}</mat-label>
      <input [attr.id]="'firstname'" autocomplete="off" formControlName="firstname" matInput />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-form">
      <mat-label>{{ 'admin-dashboard.lastname' | translate }}</mat-label>
      <input [attr.id]="'lastname'" autocomplete="off" formControlName="lastname" matInput />
    </mat-form-field>

    <div class="row mb-3">
      <section class="col-12 col-md-6 checkbox-section">
        <mat-checkbox [attr.id]="'checkbox_patient'" class="checkbox-margin" [checked]="true" disabled>
          {{ 'admin-dashboard.patient_role' | translate }}
        </mat-checkbox>
        <mat-checkbox [attr.id]="'checkbox_admin'" class="checkbox-margin" formControlName="admin">
          {{ 'admin-dashboard.admin_role' | translate }}
        </mat-checkbox>
        <mat-checkbox [attr.id]="'checkbox_ecoach'" class="checkbox-margin" formControlName="ecoach">
          {{ 'admin-dashboard.ecoach_role' | translate }}
        </mat-checkbox>
        <mat-checkbox [attr.id]="'checkbox_editor'" class="checkbox-margin" formControlName="editor">
          {{ 'admin-dashboard.editor_role' | translate }}
        </mat-checkbox>
      </section>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button
    [attr.id]="'btnCancel'"
    mat-button
    mat-dialog-close
  >
    {{ 'admin-dashboard.cancel' | translate }}
  </button>
  <app-button-feedback
    [_setId]="'btnRegisterNewAccount'"
    (click)="registerNewAccount()"
    [_defaultButtonText]="'admin-dashboard.create_new_account_confirm'"
    [_responseText]="createNewAccountResponse | async"
    [_isDisabled]="isInvalidForm()"
  ></app-button-feedback>
</div>
